import React from 'react';
import PropTypes from 'prop-types';

export function BalanceStatusBlock(props) {
  const setClassName = () => {
    return `${props.className}_status ${
      props.balanced ? 'balanced' : 'unbalanced'
    }`;
  };

  const getStatus = () => (props.balanced ? 'yes' : 'no');

  return (
    <div className={`${props.className}_block`}>
      <div className={props.className}>
        <h3>WARNING!</h3>
        <p className={`${props.className}_message`}>
          Make sure the microcentrifuge is balanced before begining your spin.
        </p>
        <p className={setClassName()}>Balanced: {getStatus()}</p>
      </div>
    </div>
  );
}

BalanceStatusBlock.propTypes = {
  /**
   * ClassName to set on status warning component
   */
  className: PropTypes.string,
  /**
   * Boolean to set the Microcentrifuge Balanced Status Yes/No
   */
  balanced: PropTypes.bool,
};

BalanceStatusBlock.defaultProps = {};
